import script from "./Informacoes.vue?vue&type=script&setup=true&lang=ts"
export * from "./Informacoes.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__